import {
    ForgotPasswordDTO,
    EmailConfirmationDTO,
    IdentityClient_V1,
    RegisterDTO,
    ResetPasswordDTO,
    UserDTO,
    UpdateUserDTO,
    ChangePasswordDTO,
    ProfileDTO,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import ApiHelper from '../utils/ApiHelper';
import Mapper from '../utils/Mapper';

export default class UserService {
    private readonly _identityClient: IdentityClient_V1;

    constructor() {
        this._identityClient = new IdentityClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public Register(dto: RegisterDTO): Promise<RegisterDTO> {        
        return ApiHelper.ParseDTO<RegisterDTO>(() => this._identityClient.register(dto));
    }

    public ConfirmEmail(id: string, code: string): Promise<EmailConfirmationDTO> {
        const dto = new EmailConfirmationDTO();
        dto.id = id;
        dto.code = code;

        return ApiHelper.ParseDTO<EmailConfirmationDTO>(() => this._identityClient.confirmEmail(dto));
    }

    public ForgotPassword(email: string, company: string) {
        const dto = new ForgotPasswordDTO();
        dto.email = email;
        dto.companyType = Mapper.MapCompanyType(company);

        return this._identityClient.forgotPassword(dto);
    }

    public ResetPassword(email: string, code: string, password: string, confirmPassword: string) {
        const dto = new ResetPasswordDTO();
        dto.email = email;
        dto.token = code;
        dto.password = password;
        dto.confirmPassword = confirmPassword;

        return ApiHelper.ParseDTO<ResetPasswordDTO>(() => this._identityClient.resetPassword(dto));
    }

    public async GetUsers(): Promise<Array<UserDTO>> {
        return this._identityClient.getUsers();
    }

    public async ToggleLockout(userId: string): Promise<void> {
        void await this._identityClient.toggleLockout(userId);
    }

    public async UpdateUser(user: UserDTO): Promise<UpdateUserDTO> {
        const dto = new UpdateUserDTO();
        dto.userId = user.userId;
        dto.firstName = user.firstName ?? '';
        dto.lastName = user.lastName ?? '';
        dto.roles = user.roles;

        return ApiHelper.ParseDTO<UpdateUserDTO>(() => this._identityClient.updateUser(<string>dto.userId, dto));
    }

    public async SendConfirmationEmail(userId: string): Promise<void> {
        void await this._identityClient.sendConfirmEmail(userId);
    }

    public async ChangePassword(currentPassword: string, newPassword: string, confirmPassword: string): Promise<ChangePasswordDTO> {
        const dto = new ChangePasswordDTO();
        dto.currentPassword = currentPassword;
        dto.newPassword = newPassword;
        dto.confirmPassword = confirmPassword;

        return await ApiHelper.ParseDTO<ChangePasswordDTO>(() => this._identityClient.changePassword(dto));
    }

    public async GetProfile(userId: string) : Promise<ProfileDTO> {

        return this._identityClient.getProfile(userId);
    }

    public async UpdateProfile(profile: ProfileDTO): Promise<ProfileDTO> {

        return ApiHelper.ParseDTO<ProfileDTO>(() => this._identityClient.updateProfile(<string>profile.userId, profile));
    }
}